import { render, staticRenderFns } from "./LoginFormInputPhone.vue?vue&type=template&id=b1b23696&scoped=true"
import script from "./LoginFormInputPhone.vue?vue&type=script&lang=js"
export * from "./LoginFormInputPhone.vue?vue&type=script&lang=js"
import style0 from "./LoginFormInputPhone.vue?vue&type=style&index=0&id=b1b23696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b23696",
  null
  
)

export default component.exports